import { render, staticRenderFns } from "./veBaseBanjiBzrShow.vue?vue&type=template&id=53e82bb9&scoped=true"
import script from "./veBaseBanjiBzrShow.vue?vue&type=script&lang=js"
export * from "./veBaseBanjiBzrShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e82bb9",
  null
  
)

export default component.exports